import { motion } from 'framer-motion';
import { useTab, Tab } from '../../../contexts/TabContext';
import './TabNav.css';

const TABS: { id: Tab; label: string }[] = [
  { id: 'current', label: 'Current' },
  { id: 'insights', label: 'Insights' },
  { id: 'historical', label: 'Historical' },
  { id: 'report', label: 'Report' },
];

export function TabNav() {
  const { activeTab, setActiveTab } = useTab();

  return (
    <nav className="TabNav" role="tablist" aria-label="Dashboard sections">
      {TABS.map((tab) => (
        <button
          key={tab.id}
          role="tab"
          aria-selected={activeTab === tab.id}
          className="TabNav-button"
          onClick={() => setActiveTab(tab.id)}
        >
          {tab.label}
          {activeTab === tab.id && (
            <motion.div
              className="TabNav-indicator"
              layoutId="tab-indicator"
              transition={{ type: 'spring', stiffness: 500, damping: 30 }}
            />
          )}
        </button>
      ))}
    </nav>
  );
}
